import { TopNav, PageShell, BackCoverFooter, BrutalistBadge } from "@/app/components/brand-scaffold";
import { siteHeaderActions, siteNavItems } from "@/app/content";
import { HomepageOperatorPersonas } from "@/design-system/patterns/homepage-operator-personas";
import { HomepageSubcontract } from "@/design-system/patterns/homepage-subcontract";

export default function OpcPage() {
  return (
    <PageShell>
      <TopNav navItems={siteNavItems} actionItems={siteHeaderActions} homeHref="/" />
      <main className="relative z-10 w-full overflow-hidden">
        <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <div className="mx-auto max-w-5xl">
            <div className="mb-8">
              <BrutalistBadge bgClass="bg-[#F97316]" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white" className="text-white">
                OPC MODEL
              </BrutalistBadge>
            </div>
            <h1 className="text-4xl sm:text-5xl font-black text-black mb-4">
              超级个体商业模式
            </h1>
            <p className="text-lg font-bold text-zinc-600 mb-8">
              One-Person Company (OPC) 如何通过 Hotline 实现能力变现。
            </p>
            <div className="border-4 border-black bg-[#FACC15]/20 p-4 mb-12 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
              <p className="text-sm font-bold text-zinc-800">
                ⚠️ 本页描述的是 CALL ANYTHING 的商业化愿景。当前 Marketplace 为 Preview 状态，法币结算尚未开放。
              </p>
            </div>

            <div className="space-y-8 mb-16">
              <h2 className="text-2xl font-black text-black border-b-4 border-black pb-2">核心思路</h2>
              <p className="text-sm text-zinc-700">
                人类公司怎么分包，Hotline 网络就怎么分包。一个人、一项手艺、一根标准化 Hotline——全球任何 Agent 都能按协议发现和调用。
              </p>
              <div className="grid gap-4 sm:grid-cols-2">
                <div className="border-4 border-black bg-white/85 p-5 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                  <h3 className="font-black mb-2">为什么是超级个体</h3>
                  <ul className="space-y-2 text-sm text-zinc-700">
                    <li>• 经验和判断力是最稀缺的供给</li>
                    <li>• AI Agent 需要外部专业能力</li>
                    <li>• Hotline 让个人能力可被全球调用</li>
                    <li>• 协议层处理身份、计量、路由</li>
                  </ul>
                </div>
                <div className="border-4 border-black bg-white/85 p-5 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                  <h3 className="font-black mb-2">收益模型</h3>
                  <ul className="space-y-2 text-sm text-zinc-700">
                    <li>• 按调用计费，Agent 消费时自动结算</li>
                    <li>• 核心逻辑留在本地，保护知识壁垒</li>
                    <li>• 7×24 自动响应，不受时区限制</li>
                    <li>• 版本迭代积累复合收益</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Reuse existing persona and subcontract sections */}
        <HomepageOperatorPersonas />
        <HomepageSubcontract />
      </main>
      <BackCoverFooter />
    </PageShell>
  );
}
